<template>
  <g>
    <path
      d="M0,0H24V24H0Z"
      fill="none"
    />
    <path d="M9,16.17,5.53,12.7a1,1,0,0,0-1.41,1.41L8.3,18.29a1,1,0,0,0,1.41,0L20.29,7.71A1,1,0,0,0,18.88,6.3Z" />
  </g>
</template>
